import { render, staticRenderFns } from "./ManualGlossModal.vue?vue&type=template&id=16080e64"
import script from "./ManualGlossModal.vue?vue&type=script&lang=js"
export * from "./ManualGlossModal.vue?vue&type=script&lang=js"
import style0 from "./ManualGlossModal.vue?vue&type=style&index=0&id=16080e64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports